import React from 'react';
import images from '../assets/images';
import './App.scss';
import Item from './Item';

export interface IProject {
  title: string;
  screenshotListType?: string;
  screenshotList: Array<string> | null;
  screenshotListType2?: string;
  screenshotList2?: Array<string> | null;
  descTitle: string;
  descList: Array<string>;
  url?: string | null;
  playStoreUrl?: string | null;
  appStoreUrl?: string | null;
}

const PROJECT_LIST: Array<IProject> = [
  {
    title: 'INTRODUCTION',
    screenshotList: null,
    descTitle:
      'UI/UX 설계부터 개발 및 배포, 운영까지 넓은 인사이트의 모바일 개발 경험을 가진 개발자입니다.',
    descList: [
      '[기술스택]',
      '',
      '- Android, iOS 네이티브 App 개발',
      '- React-Native, Flutter 크로스플랫폼 App 개발',
      '- JS, JQeury 기반 WebApp 개발',
      '- React.js, Next.js 기반 Web 개발',
      '',
      '[업종스택]',
      '',
      '- 핀테크(삼성페이)',
      '- 자동차(지도 기반 모빌리티 플랫폼)',
      '- 소셜 네트워킹(WebRTC, WebSocket 기반 음성/영상 통화구현)',
      '- 의료(비대면 진료: 음성/영상통화, PIN 암호화 본인인증 구현)',
      '- 건축공사 현장관리(삼성엔지니어링)',
      '- 중장비, 건설기계(두산 인프라코어)',
      '- 이커머스(대형 온라인 쇼핑몰)',
    ],
    playStoreUrl: null,
    appStoreUrl: null,
  },
  {
    title: '현대 Hmall',
    screenshotListType: 'horizontal',
    screenshotList: [
      images.hmall_01,
      images.hmall_02,
      images.hmall_03,
      images.hmall_04,
      images.hmall_05,
      images.hmall_06,
      images.hmall_07,
    ],
    screenshotList2: [
      images.hmall_m_01,
      images.hmall_m_02,
      images.hmall_m_03,
      images.hmall_m_04,
      images.hmall_m_05,
      images.hmall_m_06,
      images.hmall_m_07,
    ],
    descTitle: 'Next.js Web Application Project (Hyundai Home Shopping)',
    descList: [
      '2023.01 - 현재',
      '',
      '- Hmall 이벤트 홈 UI 및 로직 구현',
      '- 이벤트 템플릿별 UI 분기처리 로직 구현',
      '- 이벤트 쿠폰, 실시간 응모, 리뷰 사진/동영상 업로드 구현',
      '- 모바일 본인 인증(휴대폰 번호 인증) 구현',
    ],
    url: 'https://www.hmall.com/',
  },
  {
    title: '어디아파 - 비대면 진료 서비스',
    screenshotList: [
      images.whatailsyou_01,
      images.whatailsyou_02,
      images.whatailsyou_03,
      images.whatailsyou_04,
      images.whatailsyou_05,
      images.whatailsyou_06,
      images.whatailsyou_07,
      images.whatailsyou_08,
    ],
    descTitle: 'React-native Project (비플러스랩)',
    descList: [
      '2022.02 - 2022.12',
      '',
      '- 블록체인 기반 본인인증 시스템 구축',
      '- FCM(Push Service) 연동 모듈 구현',
      '- 스마트 건강 문진 모듈 개발',
      '- 실시간 영상 비대면 진료(WebRTC, WebSocket)',
      '- CS 및 약배송 시스템 구축',
      '- 모바일 개발 PL',
    ],
    playStoreUrl:
      'https://play.google.com/store/apps/details?id=com.whatailsyou.app',
    appStoreUrl:
      'https://apps.apple.com/kr/app/%EC%96%B4%EB%94%94%EC%95%84%ED%8C%8C-%EB%82%B4-%EC%86%90-%EC%95%88%EC%9D%98-%EC%9D%98%EC%82%AC/id1436802419',
  },
  {
    title: 'ITMS - 시험 성적서 관리 시스템 (Tablet)',
    screenshotList: [
      images.itms_app_01,
      images.itms_app_02,
      images.itms_app_03,
      images.itms_app_04,
      images.itms_app_05,
      images.itms_app_06,
      images.itms_app_07,
      images.itms_app_08,
    ],
    descTitle: 'React-native Project (Hyundai Mobis)',
    descList: [
      '2021.09 - 2022.01',
      '',
      '- Tablet 플렉서블 UI 적용',
      '- 성적서 템플릿 모바일 Rendering Engine 개발',
      '- PDF 출력, 다운로드 구현',
      '- OCR 장비 인식 기능 구현',
      '- Front-end 개발 PL',
      '',
      '- Google Play Store, Apple AppStore 미출시(in-house 배포)',
    ],
    playStoreUrl: null,
    appStoreUrl: null,
  },
  {
    title: 'ITMS - 시험 성적서 관리 시스템 (Web)',
    screenshotListType: 'horizontal',
    screenshotList: [
      images.itms_web_01,
      images.itms_web_02,
      images.itms_web_03,
      images.itms_web_04,
      images.itms_web_05,
      images.itms_web_06,
      images.itms_web_07,
      images.itms_web_08,
      images.itms_web_09,
      images.itms_web_10,
      images.itms_web_11,
    ],
    descTitle: 'React.js Project (Hyundai Mobis)',
    descList: [
      '2021.09 - 2022.01',
      '',
      '- 성적서 템플릿 생성 및 편집 Engine 개발',
      '- 성적서 템플릿 Rendering Engine 개발',
      '- PDF 출력, 다운로드 구현',
      '- Front-end 개발 PL',
    ],
    playStoreUrl: null,
    appStoreUrl: null,
  },
  {
    title: 'KIND - 프리미엄 소개팅',
    screenshotList: [
      images.kind_01,
      images.kind_02,
      images.kind_03,
      images.kind_04,
      images.kind_05,
    ],
    descTitle: 'Flutter Project (Three comma club)',
    descList: [
      '2021.04 - 2021.08',
      '',
      '- 회원가입 / 로그인 / 소셜 로그인',
      '- GA(Google Analytics) 연동',
      '- Pass 본인인증 인증 구축',
      '- WebRTC, WebSocket 이용 음성통화 / 영상통화 구축',
      '- 실시간 채팅 기능 구현',
      '- FCM(Push Service) 연동 모듈 구현',
    ],
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.kind',
    appStoreUrl:
      'https://apps.apple.com/ca/app/%EC%B9%B4%EC%9D%B8%EB%93%9C-%EA%B9%8C%EB%8B%A4%EB%A1%9C%EC%9A%B4-%EB%82%A8%EB%85%80%EB%A5%BC-%EC%9C%84%ED%95%9C-%EC%86%8C%EA%B0%9C%ED%8C%85/id1485826140',
  },
  {
    title: 'ENGINE PARTS BOOK',
    screenshotList: [
      images.engine_01,
      images.engine_02,
      images.engine_03,
      images.engine_04,
      images.engine_05,
    ],
    descTitle: 'Flutter Project (Doosan Infracore)',
    descList: [
      '2020.11 - 2021.03',
      '',
      '- 로그인, 회원가입 Legacy 시스템 연동 구축',
      '- 파츠북 PDF 분산 다운로드 구현',
      '- PDF 태그 인식 모듈 구현',
      '- Android, iOS 앱 스토어배포',
      '- 모바일, Back-end 개발 PL',
    ],
    playStoreUrl:
      'https://play.google.com/store/apps/details?id=com.doosaninfracore.enginepartsbook.rn',
    appStoreUrl: 'https://apps.apple.com/kr/app/engine-parts-book/id1550211920',
  },
  {
    title: 'Mocean - 법인카셰어링',
    screenshotList: [
      images.mocean_01,
      images.mocean_02,
      images.mocean_03,
      images.mocean_04,
      images.mocean_05,
      images.mocean_06,
      images.mocean_07,
      images.mocean_08,
      images.mocean_09,
      images.mocean_10,
      images.mocean_11,
    ],
    descTitle: 'React-native Project (Hyundai Motor Group)',
    descList: [
      '2019.03 - 2020.10',
      '',
      '- Kakao Map 라이브러리 커스터마이징',
      '- 회원가입 로그인 (Legacy 시스템 연동) 구축, SSO 연동',
      '- 차량 예약 및 예약 내역 조회 구축',
      '- 신용카드, 운전면허증 인식 구현',
      '- Bluetooth 연동 스마트키 차량 제어 기술 구현(차량 찾기, 도어 열림/닫힘, 시동 on/off)',
      '- Android, iOS 다국어 적용',
      '- 모바일 개발 PL',
    ],
    playStoreUrl:
      'https://play.google.com/store/apps/details?id=com.mocean.userapp',
    appStoreUrl:
      'https://apps.apple.com/kr/app/%EB%AA%A8%EC%85%98-%EB%B2%95%EC%9D%B8%EC%B9%B4%EC%85%B0%EC%96%B4%EB%A7%81/id1497479540',
  },
  {
    title: 'Salesman MAP',
    screenshotList: [
      images.youngmap_01,
      images.youngmap_02,
      images.youngmap_03,
      images.youngmap_04,
      images.youngmap_05,
      images.youngmap_06,
      images.youngmap_07,
      images.youngmap_08,
    ],
    descTitle: 'React-native Project (개인 프로젝트)',
    descList: [
      '- 기획, 디자인, 설계, 개발, 배포, 운영',
      '- CRM(고객관계관리) 솔루션',
      '- Google Map / Clustering 구현',
      '- 인앱결제(IAP) - 구독 서비스 구현',
      '- 사용자 백오피스 구축 (http://www.youngmap.net)',
      '- 엑셀 업로드 / 다운로드, 데이터 연동 서비스 구축',
    ],
    playStoreUrl:
      'https://play.google.com/store/apps/details?id=com.giftsets.youngmap',
    appStoreUrl:
      'https://apps.apple.com/kr/app/%EC%98%81%EB%A7%B5-%EC%84%B1%EA%B3%B5%EC%A0%81%EC%9D%B8-%EB%B9%84%EC%A7%80%EB%8B%88%EC%8A%A4%EB%A5%BC-%EC%9C%84%ED%95%9C-%EA%B3%A0%EA%B0%9D%EA%B4%80%EB%A6%AC-%EB%A7%A4%EB%8B%88%EC%A0%80/id1501942253',
  },
  {
    title: 'FREEDIVE - Ai Trainer',
    screenshotList: [
      images.freedive_01,
      images.freedive_02,
      images.freedive_03,
      images.freedive_04,
      images.freedive_05,
      images.freedive_06,
      images.freedive_07,
      images.freedive_08,
    ],
    descTitle: 'React-native Project (개인 프로젝트)',
    descList: [
      '- 기획, 디자인, 설계, 개발, 배포, 운영',
      '- 프리다이빙 스포츠 트레이닝 서비스',
      '- Firebase Cloud 서비스 활용: Authentication, Firestore, Storage, Hosting, Remote Config, Messaging',
      '- 백그라운드 타이머 서비스 구현',
      '- Audio Streaming 서비스 구현',
      '- 한, 미 다국어 적용',
    ],
    playStoreUrl:
      'https://play.google.com/store/apps/details?id=com.giftsets.freedive',
    appStoreUrl:
      'https://apps.apple.com/kr/app/freedive-training-learn/id1567940653',
  },
  {
    title: '나를 지켜주는 부적',
    screenshotList: [
      images.amulet_01,
      images.amulet_02,
      images.amulet_03,
      images.amulet_04,
      images.amulet_05,
      images.amulet_06,
      images.amulet_07,
      images.amulet_08,
    ],
    descTitle: 'React-native Project (개인 프로젝트)',
    descList: [
      '- 기획, 디자인, 설계, 개발, 배포, 운영',
      '- Firebase Cloud 서비스 활용: Authentication, Firestore, Messaging',
      '- 안드로이드 위젯 구현',
      '- 운세 알림 서비스 구현',
    ],
    playStoreUrl:
      'https://play.google.com/store/apps/details?id=com.giftsets.amulet.third',
    appStoreUrl:
      'https://apps.apple.com/kr/app/%EB%82%98%EB%A5%BC-%EC%A7%80%EC%BC%9C%EC%A3%BC%EB%8A%94-%EB%B6%80%EC%A0%81-%EC%9A%B4%EC%84%B8-%EA%B6%81%ED%95%A9-%EC%82%AC%EC%A3%BC/id1474239446',
  },
  {
    title: 'PUPPY DOG WALLPAPERS',
    screenshotList: [
      images.random_dog_01,
      images.random_dog_02,
      images.random_dog_03,
      images.random_dog_04,
    ],
    descTitle: 'React-native Project (개인 프로젝트)',
    descList: [
      '- 강아지 사진 / 일러스트 Wallpaper 서비스',
      '- 기획, 디자인, 설계, 개발, 배포, 운영',
      '- Pixabay API 사용',
      '- 이미지 프로세싱(필터) 구현, 다운로드 구현',
    ],
    playStoreUrl:
      'https://play.google.com/store/apps/details?id=com.giftsets.randomdog',
    appStoreUrl:
      'https://apps.apple.com/kr/app/%EA%B0%95%EC%95%84%EC%A7%80-%EB%B0%B0%EA%B2%BD%ED%99%94%EB%A9%B4-%EC%82%AC%EC%A7%84-%EB%8F%99%EC%98%81%EC%83%81/id1558962268',
  },
  {
    title: '산업환경 현장 모바일',
    screenshotList: null,
    descTitle: 'Android Project (Samsung Engineering)',
    descList: [
      '2018.01 - 2019.02',
      '',
      '- 산업환경 현장 모바일 (WebApp) Android 앱 개발 / 운영 (JavaScript)',
      '- 삼성엔지니어링 공사 현장 관리를 위한 웹 애플리케이션 구축 및 운영',
      '- Android 앱 유지 및 보수',
      '',
      '- In-House 배포',
    ],
    playStoreUrl: null,
    appStoreUrl: null,
  },
  {
    title: '삼성페이 Android',
    screenshotList: null,
    descTitle: 'Android Project (Samsung Electronics)',
    descList: [
      '2017.01 - 2017.12',
      '',
      '- 삼성페이 Android 네이티브 앱 개발 / 운영 (Java)',
      '- 삼페숏핑 리뉴얼 개발 (React-Native)',
      '- Android 기 출시 앱 유지 및 보수',
    ],
    playStoreUrl: null,
    appStoreUrl: null,
  },
  {
    title: '삼성페이 iOS',
    screenshotList: null,
    descTitle: 'iOS Project (Samsung Electronics)',
    descList: [
      '2015.07 - 2016.12',
      '',
      '- 삼성페이 iOS 네이티브 앱 개발 (Swift)',
      '- 회원가입 / 로그인 구현',
      '- PG사 연동 신용카드 등록 / 삭제 / 추가 기능 구현',
      '- 멤버십 카드 관리 기능 구현',
      '- iOS 미출시',
    ],
    playStoreUrl: null,
    appStoreUrl: null,
  },
  {
    title: '삼성월렛',
    screenshotList: null,
    descTitle: 'Android Project (Samsung Electronics)',
    descList: [
      '2014.12 - 2015.06',
      '',
      '- 삼성월렛 Android 네이티브 앱 개발 / 운영 (Java)',
      '- CLO 멤버십 연동 기능 구현',
      '- 스탬프 인식 라이브러리 연동 및 개발',
      '- Android 기 출시 앱 유지보수 및 배포작업',
    ],
    playStoreUrl: null,
    appStoreUrl: null,
  },
  {
    title: '삼성북스',
    screenshotList: null,
    descTitle: 'Android Project (Samsung Electronics)',
    descList: [
      '2010.02 - 2014.11',
      '',
      '- 삼성북스 Android 네이티브 앱 개발 / 운영 (Java)',
      '- 북스토어 메인 화면 개발, 결제 시스템 연동 구축',
      '- Android 앱 유지 / 보수, 업데이트 배포',
    ],
    playStoreUrl: null,
    appStoreUrl: null,
  },
];

const App: React.FC = () => {
  return (
    <div className={'App'}>
      <header className={'App-header'}>
        <div className={'title-container'}>
          <p className={'noselect'}>{'PORTFOLIOS'}</p>
        </div>
        <div className={'info-container'}>
          <p className={'info'}>{'HYEONGSEOK OH'}</p>
          <a className={'info-link'} href={'mailto:kevin85.oh@gmail.com'}>
            {'kevin85.oh@gmail.com'}
          </a>
        </div>
      </header>
      <main className={'App-main'}>
        {PROJECT_LIST.map((item, index) => {
          return <Item data={item} />;
        })}
      </main>
    </div>
  );
};

export default App;
